import React from 'react';
import { FormattedMessage } from 'react-intl';
import { searchConstants } from '../../../../search-utils/searchConstants';
import { doctrineAnalytics } from '../../../../../utils/analyticsUtils';

type Props = {
  accessPremium: boolean;
  openRestrictedModal: Function;
  onDatesUpdate: Function;
  selectedValue: { from?: string; to?: string };
};

type State = {
  from: string;
  to: string;
};

export class DateRangeSelector extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      from: props.selectedValue.from ? props.selectedValue.from : '1800',
      to: props.selectedValue.to
        ? props.selectedValue.to
        : String(searchConstants.years.yearNow),
    };
  }

  onRangeChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = evt.currentTarget;

    this.setState({
      [name]: value,
    } as Pick<State, keyof State>);
  };

  submitYearRange = (evt: React.FormEvent<HTMLFormElement>) => {
    evt.preventDefault();
    const { accessPremium, openRestrictedModal, onDatesUpdate } = this.props;
    if (!accessPremium) {
      openRestrictedModal('faceted-item');
    } else {
      const { to, from } = this.state;
      const dateRange = { to, from };
      doctrineAnalytics('Search DatePickerDayClicked', {
        ...dateRange,
        search_type: 'decision',
        type: 'year_range',
      });
      onDatesUpdate(dateRange);
    }
  };

  render() {
    const { from, to } = this.state;

    return (
      <div className="search-filters-radio__sub-content">
        <div className="search-filters-date-range">
          <form
            className="search-filters-date-range__form"
            onSubmit={this.submitYearRange}
          >
            <input
              className="search-filters-date-range__input"
              name="from"
              minLength={4}
              maxLength={4}
              value={from}
              onChange={this.onRangeChange}
              required
            />
            <input
              className="search-filters-date-range__input"
              minLength={4}
              maxLength={4}
              name="to"
              value={to}
              onChange={this.onRangeChange}
              required
            />
            <button className="search-filters-date-range__button" type="submit">
              <FormattedMessage id="search/components/aside-filters/dates/decision/DateRangeSelector.tsx/1" />
            </button>
          </form>
        </div>
      </div>
    );
  }
}
